import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { fetchGetFloorPlan } from '../shared/repositories/newbuilding-genplan-mvk/v1/get-floor-plan';
export function fetchFloorPlan(_x) {
  return _fetchFloorPlan.apply(this, arguments);
}
function _fetchFloorPlan() {
  _fetchFloorPlan = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var params, httpApi, logger, _yield$fetchGetFloorP, response, statusCode;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          params = _ref.params, httpApi = _ref.httpApi, logger = _ref.logger;
          _context.prev = 1;
          _context.next = 4;
          return fetchGetFloorPlan({
            httpApi: httpApi,
            parameters: params,
            config: {
              requestConfig: {
                headers: [['Content-Type', 'application/json']]
              }
            }
          });
        case 4:
          _yield$fetchGetFloorP = _context.sent;
          response = _yield$fetchGetFloorP.response;
          statusCode = _yield$fetchGetFloorP.statusCode;
          if (!(statusCode !== 200)) {
            _context.next = 9;
            break;
          }
          throw new Error('Ошибка при запросе плана этажа');
        case 9:
          return _context.abrupt("return", response);
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);
          logger.error(_context.t0, {
            domain: 'fetchFloorPlan'
          });
        case 15:
          return _context.abrupt("return", null);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 12]]);
  }));
  return _fetchFloorPlan.apply(this, arguments);
}